import SetupBrands from "./brands"
import SetupLayout from "./layout"

export { SetupLayout, SetupBrands }

export function SetUp() {
  return (
    <SetupLayout>
      <SetupBrands />
    </SetupLayout>
  )
}

export default SetUp
